import React from 'react';
import { GridTable } from '@components/common/grid';
import { formatWithDefault, formatCurrency } from '@common/utils';

const GridTableAnnuityMonthly = ({
  id = 'grid-policy-change-monthly',
  title,
  data,
  isCurrencyUsd,
}) => {
  return (
    <GridTable
      id={id}
      title={title}
      sideTitle={isCurrencyUsd ? '(단위: 달러)' : '(단위: 원)'}
      options={{
        data,
        colNames: ['보증기간', '연금월액', '확정연금기간', '연금월액'],
        colModel: [
          {
            name: 'lifeTimePeriod',
            index: 'lifeTimePeriod',
            formatter: formatWithDefault(
              (value, _, row) =>
                `${value}${row.lifeTimeGrtInsrnPdTyCd === '2' ? '세' : '년'}`,
            ),
          },
          {
            name: 'lifeTimePrice',
            index: 'lifeTimePrice',
            formatter: formatWithDefault(value =>
              formatCurrency(value, isCurrencyUsd),
            ),
          },
          {
            name: 'fixedPeriod',
            index: 'fixedPeriod',
            formatter: formatWithDefault(
              (value, _, row) =>
                `${value}${row.fixedGrtInsrnPdTyCd === '2' ? '세' : '년'}`,
            ),
          },
          {
            name: 'fixedPrice',
            index: 'fixedPrice',
            formatter: formatWithDefault(value =>
              formatCurrency(value, isCurrencyUsd),
            ),
          },
        ],
        multiHeaders: [
          [
            {
              startColumnName: 'lifeTimePeriod',
              numberOfColumns: 2,
              titleText: '종신연금형',
            },
            {
              startColumnName: 'fixedPeriod',
              numberOfColumns: 2,
              titleText: '확정연금형',
            },
          ],
        ],
      }}
    />
  );
};

export default GridTableAnnuityMonthly;
